import { getAssetType } from '@/api/assetType.js';
import constants from '@/constants/index.js';


export default {
    state: {
        assetTypes: [],
        assetTypeImage: null,

        isShowAssetTypeAdd: false,
        isSaveAssetTypeAdd: false,
        assetTypeDataAdd: {
            name: '',
            description: '',
        },

        isShowAssetTypeEdit: false,
        isSaveAssetTypeEdit: false,
        assetTypeDataEdit: null,
    },
    getters: {
        ASSET_TYPES: state => { return state.assetTypes },
        ASSET_TYPE_IMAGES: state => { return state.assetTypeImage },
        ASSET_TYPE_BY_NAME: state => (assetTypeName) => {
            const searchAssetTypeIndex = state.assetTypes.map(assetType => assetType.name).indexOf(assetTypeName);
            if (searchAssetTypeIndex >= 0) return state.assetTypes[searchAssetTypeIndex];
        },

        IS_SHOW_ASSET_TYPE_ADD: state => { return state.isShowAssetTypeAdd },
        IS_SAVE_ASSET_TYPE_ADD: state => { return state.isSaveAssetTypeAdd },
        ASSET_TYPE_DATA_ADD: state => { return state.assetTypeDataAdd },

        IS_SHOW_ASSET_TYPE_EDIT: state => { return state.isShowAssetTypeEdit },
        IS_SAVE_ASSET_TYPE_EDIT: state => { return state.isSaveAssetTypeEdit },
        ASSET_TYPE_DATA_EDIT: state => { return state.assetTypeDataEdit },
    },
    mutations: {
        ASSET_TYPES: (state, payload) => { state.assetTypes = payload },
        ASSET_TYPE_PUSH: (state, payload) => {
            state.assetTypes.push(structuredClone(payload));
        },

        ASSET_TYPE_IMAGES: (state, payload) => { state.assetTypeImage = payload },

        IS_SHOW_ASSET_TYPE_ADD: (state, payload) => { state.isShowAssetTypeAdd = payload },
        IS_SAVE_ASSET_TYPE_ADD: (state, payload) => { state.isSaveAssetTypeAdd = payload },
        ASSET_TYPE_DATA_ADD_UPDATE: (state, { fieldName, fieldValue }) => {
            state.assetTypeDataAdd[fieldName] = fieldValue;
        },

        IS_SHOW_ASSET_TYPE_EDIT: (state, payload) => { state.isShowAssetTypeEdit = payload },
        IS_SAVE_ASSET_TYPE_EDIT: (state, payload) => { state.isSaveAssetTypeEdit = payload },
        ASSET_TYPE_DATA_EDIT_SET: (state, payload) => {
            state.assetTypeDataEdit = structuredClone(payload);
        },
        ASSET_TYPE_DATA_EDIT_UPDATE: (state, { fieldName, fieldValue }) => {
            state.assetTypeDataEdit[fieldName] = fieldValue;
        },
    },
    actions: {
        CHECK_ASSET_TYPES: async function (context) {
            if (context.getters.ASSET_TYPES.length === 0) {
                context.commit('ASSET_TYPES', await getAssetType());
                context.commit(
                    'ASSET_TYPE_IMAGES',
                    context.getters.ASSET_TYPE_BY_NAME(constants.IMAGE_NAME).id
                );
            }
        },

        CHECK_ASSET_TYPE_ADD: async function (context) {
            const data = context.getters.ASSET_TYPE_DATA_ADD;

            if (data.name === '') {
                context.commit('IS_SAVE_ASSET_TYPE_ADD', false);
                return 'To create a asset type, enter a name'
            }

            context.commit('IS_SAVE_ASSET_TYPE_ADD', true);
            return '';
        },
        CHECK_ASSET_TYPE_EDIT: async function (context) {
            const data = context.getters.ASSET_TYPE_DATA_EDIT;

            if (data.name === '') {
                context.commit('IS_SAVE_ASSET_TYPE_EDIT', false);
                return 'To save a asset type, enter a name'
            }

            context.commit('IS_SAVE_ASSET_TYPE_EDIT', true);
            return '';
        },
    }
}